const Mapping = {
    Specialities: {
        PrimarySpecialty: 'text',
        OtherSpecialty: 'text'
    },
    Specialities_Open_Data: {
        OtherSpecialty: 'text'
    },
    Identifiers: {
        Type: 'text',
        Id: 'text',
        SubType: 'text'

    },
    Phone: {
        Phone: 'text'    
       },
    Email: {
        Email: 'text'      
       },
    
    Relation: {
        HCO: '',
        Rank: 'text',
        AddressLine1: 'text',
        City: 'text',
        Zip: 'text',
        StateProvince: 'text',
        Country: ''
        

    },
    Address: {
        AddressLine1: 'text',
        StateProvince: 'text',
        City: 'text',
        Zip: 'text',
        Country: 'text',
        Rank: 'text'
    }
}

export default Mapping;